import { DigitalAsset } from '@promoboxx/graphql-gateway-types'
// @ts-ignore
import { Image, Video, Transformation, Placeholder } from 'cloudinary-react'
import { ReactNode, useState } from 'react'
import { makeStyles } from 'tss-react/mui'

import DigitalAssetIcon from './DigitalAssetIcon'
import ExternalVideo from './ExternalVideo'

const useStyles = makeStyles()((theme) => ({
  mediaRoot: {
    'borderTopLeftRadius': theme.shape.borderRadius,
    'borderTopRightRadius': theme.shape.borderRadius,
    'backgroundColor': theme.palette.grey[100],
    'position': 'relative',
    'height': '0',
    'paddingBottom': '56.25%',
    'overflow': 'hidden',
    '& img, & video': {
      position: 'absolute',
      // Using width/height vs top/left/bottom/right makes objectFit work.
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },
  channelIcon: {
    color: theme.palette.primary.main,
    margin: theme.spacing(0, 1),
  },
  channelIconIneligible: {
    color: theme.palette.text.secondary,
    opacity: 0.3,
  },
  eligibleChannelRoot: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  fileIconRoot: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ccc',
  },
}))

const Media = ({
  digitalAsset,
  width = 300,
}: {
  digitalAsset: DigitalAsset
  width?: number
}) => {
  const { classes } = useStyles()
  const [imageOrVideoIsBroken, setImageOrVideoIsBroken] = useState(false)
  let MediaType: ReactNode = null
  if (digitalAsset.file) {
    switch (digitalAsset.file.resource_type) {
      case 'raw':
        MediaType = (
          <div className={classes.fileIconRoot}>
            <DigitalAssetIcon
              className="fa-4x"
              fileName={digitalAsset.download_url || ''}
            />
          </div>
        )
        break
      case 'image':
        MediaType = imageOrVideoIsBroken ? (
          <div className={classes.fileIconRoot}>
            <DigitalAssetIcon
              className="fa-4x"
              fileName={digitalAsset.download_url || ''}
            />
          </div>
        ) : (
          <Image
            onError={() => setImageOrVideoIsBroken(true)}
            format={'jpg'}
            loading={'lazy'}
            publicId={digitalAsset.file.public_id}
          >
            <Transformation crop={'fill'} width={width} />
            <Placeholder type={'pixelate'} />
          </Image>
        )
        break
      case 'video':
        MediaType = imageOrVideoIsBroken ? (
          <div className={classes.fileIconRoot}>
            <DigitalAssetIcon
              className="fa-4x"
              fileName={digitalAsset.download_url || ''}
            />
          </div>
        ) : (
          <Video
            onError={() => setImageOrVideoIsBroken(true)}
            autoPlay={false}
            controls={true}
            publicId={digitalAsset.file.public_id}
          />
        )
        break
    }
  } else if (digitalAsset.external_video_url) {
    MediaType = <ExternalVideo url={digitalAsset.external_video_url} />
  }
  return <div className={classes.mediaRoot}>{MediaType}</div>
}

export default Media
